<template>
  <div>
    <modal-confirmation
      id="samplesUpdateUtilConfirmationModal"
      ref="confirmationModal"
      :content="message"
    />
  </div>
</template>

<script>
import ModalConfirmation from '@/components/modals/ModalConfirmation'

export default {
    name: 'SamplesUpdateUtil',
    components: {
        ModalConfirmation
    },
    props: {
    },
    data() {
        return {
            message: ''
        }
    },
    methods: {
        async updateSample(labId, casId, sampleId, sample, sampleService) {
            const [originalError, originalResponse] = await this.$_toCall(sampleService.updateSample(labId, casId, sampleId, sample), false)
            if (!originalError) {
                return [originalError, originalResponse]
            }
            let error, response
            let cancelPreviousAutomatisms = false
            let shouldAddPreformattedInsteadOfReplacing = false
            let applyTotalReplace = false
            let shouldCheckThatSectionsCanBeAdded = false
            this.updateLoading(false)
            if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_DO_NOT_APPLY_ANY) {
                // DO NOT APPLY
                const applyAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.ignoringAssociatedAutomatisms'))
                if (applyAutomatisms) {
                    this.updateLoading(true);
                    [error, response] = await this.$_toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                    this.updateLoading(false)
                }
                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_APPLY_WITHOUT_APPLYING_PREFORMATTED) {
                // APPLY
                const applyAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.associatedAutomatisms'))
                this.updateLoading(true)
                if (applyAutomatisms) {
                    [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                } else {
                    [error, response] = await this.toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                }
                this.updateLoading(false)

                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_APPLY_PREFORMATTED) {
                // APPLY AND APPLY_PREFORMATTED
                const applyAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.associatedAutomatisms'))
                if (applyAutomatisms) {
                    shouldAddPreformattedInsteadOfReplacing = await this.askAndGetAnswer(this.$t('global.modal.automatism.preformatted.addOrReplace'))
                    applyTotalReplace = !shouldAddPreformattedInsteadOfReplacing && await this.askAndGetAnswer(this.$t('global.modal.preformatted.totalReplaceOrPartialReplace'))
                    shouldCheckThatSectionsCanBeAdded = shouldAddPreformattedInsteadOfReplacing && true
                    this.updateLoading(true);
                    [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                    this.updateLoading(false)
                    if (error && error.response && error.response.data.code === this.$apiExceptions.PREFORMATTED_CANNOT_ADD_SOME_SECTIONS) {
                        const continueAdding = await this.askAndGetAnswer(this.$t('global.modal.preformatted.continueAdding'))
                        if (continueAdding) {
                            shouldCheckThatSectionsCanBeAdded = false
                            this.updateLoading(true);
                            [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                            this.updateLoading(false)
                        }
                    }
                } else {
                    this.updateLoading(true);
                    [error, response] = await this.toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                    this.updateLoading(false)
                }

                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_CANCEL) {
                // CANCEL
                cancelPreviousAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.cancelAssociatedAutomatisms'))
                this.updateLoading(true)
                if (cancelPreviousAutomatisms) {
                    [error, response] = await this.toCall(sampleService.cancelAutomatismsAndUpdateSample(labId, casId, sampleId, sample))
                } else {
                    [error, response] = await this.toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                }
                this.updateLoading(false)

                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_WITHOUT_APPLYING_PREFORMATTED) {
                // APPLY AND CANCEL
                const applyAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.associatedAutomatisms'))
                cancelPreviousAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.cancelAssociatedAutomatisms'))
                this.updateLoading(true)
                if (applyAutomatisms) {
                    [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                } else if (cancelPreviousAutomatisms) {
                    [error, response] = await this.toCall(sampleService.cancelAutomatismsAndUpdateSample(labId, casId, sampleId, sample))
                } else {
                    [error, response] = await this.toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                }
                this.updateLoading(false)

                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_APPLY_AND_CANCEL_AND_APPLY_PREFORMATTED) {
                // APPLY AND CANCEL AND APPLY_PREFORMATTED
                const applyAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.associatedAutomatisms'))
                cancelPreviousAutomatisms = await this.askAndGetAnswer(this.$t('global.modal.automatism.cancelAssociatedAutomatisms'))
                if (applyAutomatisms) {
                    shouldAddPreformattedInsteadOfReplacing = await this.askAndGetAnswer(this.$t('global.modal.automatism.preformatted.addOrReplace'))
                    applyTotalReplace = !shouldAddPreformattedInsteadOfReplacing && await this.askAndGetAnswer(this.$t('global.modal.preformatted.totalReplaceOrPartialReplace'))
                    shouldCheckThatSectionsCanBeAdded = shouldAddPreformattedInsteadOfReplacing && true
                    this.updateLoading(true);
                    [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                    this.updateLoading(false)
                    if (error && error.response && error.response.data.code === this.$apiExceptions.PREFORMATTED_CANNOT_ADD_SOME_SECTIONS) {
                        const continueAdding = await this.askAndGetAnswer(this.$t('global.modal.preformatted.continueAdding'))
                        if (continueAdding) {
                            shouldCheckThatSectionsCanBeAdded = false
                            this.updateLoading(true);
                            [error, response] = await this.toCall(sampleService.launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample))
                            this.updateLoading(false)
                        }
                    }
                } else if (cancelPreviousAutomatisms) {
                    this.updateLoading(true);
                    [error, response] = await this.toCall(sampleService.cancelAutomatismsAndUpdateSample(labId, casId, sampleId, sample))
                    this.updateLoading(false)
                } else {
                    this.updateLoading(true);
                    [error, response] = await this.toCall(sampleService.updateSampleFields(labId, casId, sampleId, sample))
                    this.updateLoading(false)
                }

                return this.returnErrorOrSuccess(error, response)
            } else if (originalError.response.data.code === this.$apiExceptions.CONCURRENCY_ERROR) {
                return this.processBasicConcurrencyConflict(this.$tc('global.sample', 1), originalError, () => {
                    sample.originalConcurrencyUpdatedAt = originalError.response.data.currentConcurrencyUpdatedAt
                    return this.updateSample(labId, casId, sampleId, sample, sampleService)
                })
            } else if (originalError.response.data.code === this.$apiExceptions.MORE_THAN_ONE_ASSAY_APPLIED_BY_AUTOMATISMS_TO_A_SAMPLE_ON_SLIDE) {
                this.$_showWarningModal(originalError.response.data.message)
            } else {
                this.showErrorModalGlobalFromErrorResponse(originalError, this.$t('component.modalError.errorOnSavingSample'))
                return [originalError, originalResponse]
            }
        },
        async returnErrorOrSuccess(error, response) {
            if (error) {
                if (error.response && error.response.data.code === this.$apiExceptions.RELAUNCH_AUTOMATISMS_EXISTS_CANCEL_INCOMPLETE) {
                    this.updateModalStateGlobal({
                        message: this.$t('global.modal.automatism.cancelAutomatismsFailed'),
                        icon: 'fas fa-exclamation',
                        state: 'vt-modal vt-modal--warning' })
                } else {
                    this.showErrorModalGlobal(this.$t('component.modalError.errorOnSavingSample'))
                }
                return null
            } else {
                return response
            }
        },
        async askAndGetAnswer(question) {
            return new Promise((resolve) => {
                this.message = question
                this.$refs.confirmationModal.ask(async () => {
                    resolve(true)
                },
                async () => {
                    resolve(false)
                })
            })
        }
    }
}

</script>
